import createSvgIcon from '../Utils/CreateSvgIcon';

export const ArrowLeft = createSvgIcon(
  <path
    clipRule="evenodd"
    d="M6.82929 13.0009L21 13L20.9999 11L6.82757 11.0009L13.6066 4.22183L12.1924 2.80762L3 12L12.1934 21.1934L13.6076 19.7791L6.82929 13.0009Z"
    fillRule="evenodd"
  />,
  'ArrowLeft',
);
